import { CumulioDashboard } from '../models/dashboard.model';

export const reloadDashboard = <T extends CumulioDashboard>(dashboardComponent: T, iframe: HTMLIFrameElement): Promise<void> => {
  if (iframe) {
    iframe.contentWindow.postMessage(
      { action: 'reloadDashboard', _version: dashboardComponent.VERSION },
      '*'
    );
    return Promise.resolve();
  }

  return Promise.reject(new Error('Cannot retrieve contentWindow.'));
};
